import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const TableDownstreamSheetsQueryGql: DocumentNode = gql`
query TableDownstreamSheetsQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  tables(filter: { id: $tableId }) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowDataFragment
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
